import { z } from "zod/v4";

export const MediaPartSchema = z.object({
  type: z.literal("file-data"),
  data: z.string(),
  url: z.string().optional(),
  fileName: z.string().optional(),
  mediaType: z.string(),
});

export type MediaUIPartType = z.infer<typeof MediaPartSchema>;
